/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        template: `
sub cmd_${NAME}(byref data as string)
'****cmd_${NAME}****'
end sub
`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
declare sub cmd_${NAME}(byref data as string)`,
    });

    return blocks;
};
